module.exports = __webpack_public_path__ + "static/7-19071bfc65fe71e681004f3d1eaa274a.jpeg";